"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EvaluationCount = void 0;
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const GlobalStateProvider_1 = require("../../../../../GlobalStateProvider");
const common_1 = require("../../../../../common");
const EvaluationCountTable_1 = require("./EvaluationCountTable");
// 평가 항목 수
exports.EvaluationCount = react_1.default.memo(({ isReserve, evalItemCnt, evalData, subjectId, setEvalItemCnt, setEvalData, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { isMobile, isTablet } = (0, GlobalStateProvider_1.useGlobalState)();
    const evalRef = react_1.default.useRef(null);
    // (onClick) 평가 항목 수 업데이트
    const applyEvalItemCnt = () => {
        if (evalRef.current) {
            const element = evalRef.current;
            const nubmer = Number(element.value);
            if (nubmer <= 0) {
                alert(t('assignment.errMoreThan'));
                return;
            }
            else if (nubmer > 100) {
                alert(t('assignment.errLessThan'));
                return;
            }
            setEvalItemCnt(nubmer);
        }
    };
    react_1.default.useEffect(() => {
        if (evalRef.current)
            evalRef.current.value = evalItemCnt.toString();
    }, [evalItemCnt]);
    const evalCntInfo = (0, react_1.useMemo)(() => (react_1.default.createElement("div", { style: {
            display: 'flex',
            flexDirection: 'row',
            gap: 16,
            width: isMobile ? '100%' : undefined,
        } },
        react_1.default.createElement(common_1.InputElement, { ref: evalRef, type: "number", isEnterPrevent: true, onSubmit: applyEvalItemCnt, min: 0 }),
        react_1.default.createElement(common_1.Button, { className: `btn_tur ${isMobile ? 'mobile-sm' : 'sm'}`, text: "common.apply", onClick: applyEvalItemCnt, styles: {} }))), [evalRef]);
    const evalTable = (0, react_1.useMemo)(() => (react_1.default.createElement(EvaluationCountTable_1.EvaluationCountTable, { evalItemCnt: evalItemCnt, evalData: evalData, subjectId: subjectId, setEvalData: setEvalData })), [evalItemCnt, subjectId, evalData]);
    const evalCntInfoWrap = (0, react_1.useMemo)(() => (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "task-label", style: isMobile
                ? {
                    width: 'unset',
                    display: 'flex',
                    alignItems: 'center',
                    minWidth: 'fit-content',
                }
                : { minWidth: 'fit-content' } }, t('assignment.evalItemCnt')),
        react_1.default.createElement("div", { className: "fext-field", style: { flexDirection: 'column', alignItems: 'flex-start' } },
            evalCntInfo,
            !isMobile && evalTable))), [evalCntInfo, isMobile, evalTable]);
    return (react_1.default.createElement("div", { className: "field-global-001", style: {
            alignItems: 'flex-start',
            flexDirection: 'column',
        } }, isMobile ? (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "eval-info-wrap" }, evalCntInfoWrap),
        react_1.default.createElement("div", { className: "eval-table-wrap" }, evalTable))) : (evalCntInfoWrap)));
});
